import React from 'react';
import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../../Helpers/ValidityHelper';
import TpPaymentRequestStatusChangeItem from '../../../../Domain/TpPaymentRequestStatusChangeItem';
import ThirdPartyJobPaymentsService from '../../../../Services/ThirdParty/ThirdPartyJobPaymentsService';

export default class TpPaymentRequestStatusChangeWindowDescription extends React.Component {
  static titleForCreate = 'Payment Request Status Change';
  static titleForEdit = 'Payment Request Status Change';
  static itemType = TpPaymentRequestStatusChangeItem;
  static serviceFunction = (edited) => ThirdPartyJobPaymentsService.ExecuteWorkflowAction(edited);

  getSelected() {}

  getSearchParameters() {}

  getAllItemInTheSearchAreSelected() {}

  static validityCheckerForComment(e, editedItem) {
    if (
      editedItem &&
      (['10', '11', '12', '14', '15'].includes(editedItem.Action) ||
        // If submitting and more info was requested, comment is also required
        (['9', '13'].includes(editedItem.Action) && editedItem.InfoRequested === true)) &&
      editedItem.Comment === ''
    ) {
      return "This field can't be empty.";
    }
    return '';
  }

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'Action',
          label: 'Action',
          className: 'col-12',
          type: InputTypesEnum.TpPaymentRequestStatusChangeSelect,
          EntityId: 'TpEvaluatorTpJobPaymentId',
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'Comment',
          label: 'Comment',
          className: 'col-12',
          type: InputTypesEnum.TextBox,
          validityChecker: TpPaymentRequestStatusChangeWindowDescription.validityCheckerForComment,
        },
      ],
    },
  ];
}
